export enum POST_PUBLISHING_DIALOG_ACCESS_ACTION {
    save = 'save',
    publish = 'publish',
    saveAndPublish = 'saveAndPublish',
}
